//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import StakingCurrencies from '~/views/Staking/StakingCurrencies/StakingCurrencies.vue';
import StakingLogs from '~/views/Staking/StakingLogs/StakingLogs.vue';

export default {
  components: {
    StakingCurrencies,
    StakingLogs,
  },

  async mounted() {
    this.setGeneralLoader(true);
    await Promise.allSettled([
      this.loadStakingCurrencies(),
      this.loadStakingLogs(),
    ]);
    this.setGeneralLoader(false);
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader']),
    ...mapActions('stakingCurrencies', {
      loadStakingCurrencies: 'loadData',
    }),
    ...mapActions('stakingLogs', {
      loadStakingLogs: 'loadData',
    }),
  },
};
